import baseService from './baseService.js';

export function unsubscribeRefrralRoundup(params) {
    return baseService.get(`unsubscribe/${params}`);
}
